var _g, _rect, _rect2, _rect3, _rect4, _path, _g2, _g3, _g4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcContractServiceMain(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 119,
    viewBox: "0 0 132 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2031_869)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 39.9644,
    width: 78.2365,
    height: 105.174,
    rx: 3.03883,
    fill: "#F4F4F4"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 53.5928,
    y: 46.6025,
    width: 49.5712,
    height: 2.51182,
    rx: 1.25591,
    fill: "#DFDFDF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 53.5928,
    y: 55.9521,
    width: 49.5712,
    height: 2.51182,
    rx: 1.25591,
    fill: "#DFDFDF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 53.5928,
    y: 65.3008,
    width: 49.5712,
    height: 2.51182,
    rx: 1.25591,
    fill: "#DFDFDF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 53.5928,
    y: 74.6504,
    width: 35.6221,
    height: 2.51182,
    rx: 1.25591,
    fill: "#DFDFDF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.2025 23.4212V32.1979H73.0451V23.4212H74.2025ZM72.37 23.6141V31.8121H71.203V28.9187H69.9588V27.9253H71.203V26.7293H70.1228C69.7129 28.176 68.8256 29.4009 67.1812 30.375L66.4578 29.507C68.2372 28.4557 69.0185 27.1778 69.1873 25.4562H66.969V24.4628H70.4121C70.4121 24.9016 70.3832 25.326 70.335 25.7359H71.203V23.6141H72.37ZM83.23 24.5785V25.5719H82.0919V26.4689H83.23V27.4912H82.0919V28.6004H80.8574V23.4212H82.0919V24.5785H83.23ZM82.0919 28.9476V32.1979H80.8574V29.941H76.1797V28.9476H82.0919ZM77.5974 23.9034C78.9574 23.8938 79.9893 24.8004 79.9893 26.0349C79.9893 27.2983 78.9574 28.1857 77.5974 28.1857C76.2279 28.1857 75.1863 27.2983 75.1863 26.0349C75.1863 24.8004 76.2279 23.8938 77.5974 23.9034ZM77.5974 24.9547C76.903 24.9547 76.3919 25.3501 76.4015 26.0349C76.3919 26.739 76.903 27.144 77.5974 27.144C78.2726 27.144 78.7837 26.739 78.7934 26.0349C78.7837 25.3501 78.2726 24.9547 77.5974 24.9547ZM86.9818 25.408C86.9818 27.0572 87.6472 28.6582 89.1132 29.2948L88.361 30.2786C87.3868 29.8011 86.7358 28.9283 86.3741 27.8481C85.9884 28.9958 85.3132 29.9362 84.3102 30.4329L83.5386 29.4298C85.0432 28.7547 85.7279 27.0572 85.7376 25.408V24.0963H86.9818V25.408ZM91.0711 23.4212V32.2172H89.8559V27.173H88.1295V26.1796H89.8559V23.4212H91.0711Z",
    fill: "#374969"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2031_869)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 63,
    r: 25,
    fill: "#BDE9FF"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_2031_869)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.7969 84.9216C60.4936 80.6508 65.7028 72.4414 65.7028 63.0154C65.7028 54.3073 61.2568 46.6376 54.511 42.1523H34.4082V84.9216H52.7969Z",
    fill: "#F4F4F4"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_2031_869)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.7029 63.0152C61.7029 74.6328 52.2849 84.0508 40.6673 84.0508C29.0496 84.0508 19.6316 74.6328 19.6316 63.0152C19.6316 51.3975 29.0496 41.9795 40.6673 41.9795C52.2849 41.9795 61.7029 51.3975 61.7029 63.0152ZM65.7029 63.0152C65.7029 76.842 54.4941 88.0508 40.6673 88.0508C36.8752 88.0508 33.2801 87.2078 30.059 85.6988L10.8491 110.79L4.49702 105.926L23.4413 81.1826C18.6313 76.6203 15.6316 70.168 15.6316 63.0152C15.6316 49.1883 26.8404 37.9795 40.6673 37.9795C54.4941 37.9795 65.7029 49.1883 65.7029 63.0152Z",
    fill: "#B9B9B9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2031_869",
    x: 39.9644,
    y: 0,
    width: 84.314,
    height: 111.251,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.03883,
    dy: 3.03883
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.51941
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2031_869"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2031_869",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2031_869",
    x: 12,
    y: 38,
    width: 58,
    height: 58,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2031_869"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2031_869",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2031_869",
    x: 30.4082,
    y: 42.1523,
    width: 39.2944,
    height: 50.7695,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2031_869"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2031_869",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_2031_869",
    x: 0.49707,
    y: 37.9795,
    width: 69.2061,
    height: 80.8105,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2031_869"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2031_869",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcContractServiceMain);
export default __webpack_public_path__ + "static/media/IcContractServiceMain.94d93894dde5cff3842d7e48004d0881.svg";
export { ForwardRef as ReactComponent };